import i18next from 'i18next';

i18next.addResources('en', 'ErrorScreen', {
  message: 'An error has ocurred',
  button: 'Reload'
});
